<template>
  <div
    class="custom-control mt-3"
    :class="{
      [`custom-${type}`]: !!type,
      'pl-0': type !== 'switch' && !noPl,
      'choose-one': $slots.prefix
    }"
  >
    <slot name="prefix" />
    <input
      :id="typeof checked === 'boolean' ? name : `${name}-${value}`"
      :type="inputTypes"
      :name="name"
      class="custom-control-input"

      :checked="typeof checked === 'boolean' ? checked : checked.includes(value)"
      :value="typeof checked === 'boolean' ? checked : checked.includes(value)"
      @change="onChange"
    >
    <label
      class="custom-control-label"
      :for="typeof checked === 'boolean' ? name : `${name}-${value}`"
    >
      {{ label }}
      <slot name="label" />
    </label>
  </div>
</template>
<script>
export default {
  name: 'CheckInput',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: [Boolean, Array],
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'checkbox',
      validator: value =>
        ['radio', 'checkbox', 'switch'].indexOf(value) !== -1
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    noPl: Boolean
  },
  computed: {
    inputTypes () {
      return this.type === 'switch' ? 'checkbox' : this.type
    }
  },
  methods: {
    onChange (e) {
      if (typeof this.checked === 'boolean') {
        this.$emit('change', e.target.checked)
      } else {
        if (this.type === 'radio') {
          this.checked.splice(0, this.checked.length)
          this.checked.push(this.value)
        } else if (this.type === 'checkbox') {
          if (this.checked.includes(this.value)) {
            this.checked.splice(this.checked.indexOf(this.value), 1)
          } else {
            this.checked.push(this.value)
          }
        }

        this.$emit('change', this.checked)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .custom-control-label {
    line-height: 24px;
  }
  .custom-switch {
    padding-left: 1.2rem;
  }
  .choose-one {
    &.custom-switch {
      padding-left: 0;
    }
    .custom-control-label {
      margin-left: 40px;
    }
  }
</style>
